var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100",on:{"click":_vm.onClick,"mouseover":_vm.onMouseOver,"mouseleave":function($event){return _vm.$emit('mouseleave', $event)},"touchstart":_vm.onTouchStart,"touchend":_vm.onTouchEnd}})}
var staticRenderFns = []

export { render, staticRenderFns }